import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useRowReminders } from '../components/TaskRowData'
import { isStandardReminder } from '@/src/renderer/lib/db/models'
import { reminderLabel } from '../utils/reminderLabels'

const NONE: readonly string[] = []

/**
 * **Die eigenen Erinnerungen einer Aufgabe, beschriftet** — für die Glocke an der Zeile
 * (`ReminderMark`). Die Standard-Erinnerung zählt nicht mit: Sonst trüge jede Aufgabe mit Uhrzeit
 * eine Glocke. In einer Liste aus deren Bündel (`TaskRowDataScope`, #303), sonst eine Abfrage je Zeile.
 */
export function useOwnReminderLabels(taskId: string | undefined): readonly string[] {
  const { t, i18n } = useTranslation()
  const reminders = useRowReminders(taskId)
  const locale = i18n.language || 'de'
  return useMemo(() => {
    const own = (reminders ?? []).filter(reminder => !isStandardReminder(reminder))
    // Stabil, solange nichts da ist — die Zeile rendert sonst bei jeder Abfrage neu.
    if (own.length === 0) return NONE
    const now = new Date()
    return own.map(reminder => reminderLabel(reminder, null, now, t, locale))
  }, [reminders, t, locale])
}
